<div class="loading-container">
	<img src="assets/logo.gif" class="loader-img" height="50" width="50" alt="loader" srcset="" />
</div>
